import { Box, BoxProps, useToken } from '@chakra-ui/react';
import styleguide from '@common/styleguide';
import { toPx } from '@common/util/styles';

type Direction = 'left' | 'right' | 'up' | 'down';

export interface FadeEdgeProps extends BoxProps {
    direction: Direction;
}

const SIZE = 20;

export default function FadeEdge({
    direction,
    color = styleguide.colors.white,
    ...props
}: FadeEdgeProps) {
    // Chakra's types are wonky here, but this works & follows their docs:
    // https://chakra-ui.com/docs/hooks/use-token
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const [colorHex] = useToken('colors', [color]);
    const isHorizontal = direction === 'up' || direction === 'down';

    return (
        <Box
            position="absolute"
            zIndex={3}
            boxShadow={`0 0 ${toPx(SIZE)} ${toPx(SIZE)} ${colorHex}`}
            w={isHorizontal ? `calc(100% - ${toPx(SIZE * 2)})` : undefined}
            h={!isHorizontal ? `calc(100% - ${toPx(SIZE * 2)})` : undefined}
            {...props}
        />
    );
}
